import makeStyles from '@mui/styles/makeStyles'
import { paidConsumerDesktopNavHeight, paidConsumerMobileNavHeight } from '../../../../components/app-toolbar-paid-consumer/style'
import { trialBannerHeight } from '../../../../components/app-toolbar-paid-consumer/navigation/style'

export const useStyles = makeStyles(({ breakpoints, palette }) => ({
  appBarContainer: {
    position: 'fixed',
    zIndex: 1200,
    background: palette.white.main,
    top: 0,
    left: 0,
    width: '100%',
    padding: 0
  },
  container: {
    minHeight: '100vh',
    marginTop: ({ isTrialBannerVisible }) => isTrialBannerVisible ? paidConsumerMobileNavHeight + trialBannerHeight : paidConsumerMobileNavHeight,
    [breakpoints.up('lg')]: {
      minHeight: '100vh',
      marginTop: ({ isTrialBannerVisible }) => isTrialBannerVisible ? paidConsumerDesktopNavHeight + trialBannerHeight : paidConsumerDesktopNavHeight
    }
  },
  mainContainer: {
    flex: 1
  }
}))
